module.exports = __webpack_public_path__ + "static/media/26-dic-wirebit-celular.66590476.svg";